module.exports = __webpack_public_path__ + "img/activitySquare-active.558045ea.svg";